<template>
  <v-edit-dialog
      ref="editSelectDialog"
      v-bind="$attrs"
      v-on="$listeners"
      :cancel-text="getCancelText"
      :large="large"
      :Select_Items="Select_Items"
      :persistent="persistent"
      :return-value.sync="inputValue"
      :save-text="getSaveText"
      :value-text.sync="valueText"
      @cancel="cancel"
      @close="close"
      @open="open"
      @save="save"
      :rules="getRules">
    {{ getValueText }}
    <v-icon v-if="TypeIcon" :size="24">{{ TypeIcon }}</v-icon>
    <template v-slot:input>
      <template v-if="haveSlot">
        <slot name="input"></slot>
      </template>
      <template v-else>
        <app-container>
          <app-row danse>
            <app-auto-select
              :ref="name"
              :name="name"
              :rules="getRules"
              v-model="inputValue"
              v-bind="$attrs"
              :errors="componentErrors"
              :items="Select_Items"/>
          </app-row>
        </app-container>
      </template>
      <slot v-bind="{errors}"></slot>
    </template>
  </v-edit-dialog>
</template>
<script>

export default {
  name: 'DatatableEditSelectDialog',
  props: {
    value: {},
    type: {
      type: String,
      default: 'text',
      validator(type) {
        const types = ['text', 'number', 'price', 'float'];
        const r = types.indexOf(type) >= 0;
        if(!r) {
          console.error('Available types is: ' + types.join(', '));
        }
        return r;
      }
    },
    persistent: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: true
    },
    item: {
      type: Object,
      require: true
    },
    Select_Items: {
      type: Array,
      require: true
    },
    name: {
      require: true
    },
    cancelText: {
      type: String,
      default: () => 'cancel'
    },
    saveText: {
      type: String,
      default: () => 'save'
    },
    valueText: {
      type: String,
      default: () => ''
    },
    TypeIcon: {
      type: String,
      default: () => undefined
    },
    updateMethod: {
      type: Function,
      require: true
    },
    required: {
      type: Boolean,
      default: () => false
    },
    rules: {
      type: [Array, String],
      default: () => ''
    },
  },
  data() {
    return {
      inputValue: undefined,
      errors: {}
    };
  },
  methods: {
    iniComp() {
      if(this.haveErrors){}
      else{
        this.inputValue = this.value;
        this.ViewValueText = this.valueText;
      }
    },
    openEditDialog() {
      const ref = this.$refs.editSelectDialog;
      ref && (ref.isActive = !0);
    },
    updateValue() {
      this.$emit('input', this.inputValue);
    },
    saved() {
      this.$emit('refresh');
    },
    save() {
      let name = this.name;
      ['_to_yes', '_to_string', 'ToString'].forEach((v) => name.substr(-v.length) === v && (name = name.split(v)[0]));
      this.errors = {};
      if(this.updateMethod) {
        const params = {[this.name]: this.inputValue};
        this.updateMethod(this.item.id, params)
          .then(({data}) => {
            if(data && data.success === true) {
              const a = this.alertSuccess(data.message);
              if(data.data&&data.data.user_type_to_string){
                this.ShowValueText = data.data.user_type_to_string;
              }
              this.updateValue();
              this.errors = {};
              a.finally(() => this.saved());
            }
          })
          .catch(({response}) => {
            const {data} = response || {};
            // data && data.message && this.alertError(data.message);
            this.errors = data && data.errors || {};
            this.$nextTick(() => this.openEditDialog());
          });
      }
    },
    cancel() {
      this.$emit('cancel', this.item);
    },
    open() {
      this.iniComp();
      this.$emit('open', this.item);
    },
    close() {
      this.$emit('close', this.item);
      this.errors = {};
    }
  },
  mounted() {
    // console.lqog(this.TypeIcon);
    // console.log(this.getErrorCount);
    this.iniComp();
  },
  computed: {
    haveErrors() {
      return this.componentErrors.length > 0;
    },
    componentErrors() {
      let name = this.name;
      ['_to_yes', '_to_string', 'ToString'].forEach((v) => name.substr(-v.length) === v && (name = name.split(v)[0]));
      return this.errors && name && this.errors[name] ? this.errors[name] : [];
    },
    componentName() {
      return `app-${this.type.toLowerCase()}-input`;
    },
    haveSlot() {
      return this.$scopedSlots['input'] !== undefined;
    },
    getValueText() {
      return this.ShowValueText;
    },
    getSaveText() {
      return this.parseAttribute(this.saveText);
    },
    getCancelText() {
      return this.parseAttribute(this.cancelText);
    },
    getRules() {
      let rules = this.rules || [];
      rules = typeof rules === 'string' ? rules.split('|') : rules;
      if(this.required === true && rules.indexOf('required') === -1) {
        rules.push('required');
      }
      return rules.join('|');
    },
    getErrorCount() {
      return this.errorCount === undefined ? 1 : (parseInt(this.errorCount) || 1);
    },
    getErrorMessages() {
      const provider = this.$refs.provider;
      let errors = [...this.errors];
      provider && (errors = [...errors, ...provider.errors]);

      return errors;
    },
    ShowValueText:{
      get(){
        return this.valueText!==''?this.valueText:this.value;
      },
      set(n){
        this.$emit('update:valueText', n);
      }
    },
  }
};
</script>
